import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import SingleFormLayout from '../../../../../../../../baseComponents/Layout/SingleFormLayout'

interface SupplierNotesProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
    getData: () => Promise<void>
}

const SupplierNotes: React.FC<SupplierNotesProps> = ({ basicData, userPermissions, getData }) => {
    const { t } = useTwinTranslation()

    const fields: FormRender<SupplierModelType> = [
        {
            cols: 1,
            title: t('notesSupplier', 'Notas del Proveedor'),
            elements: [
                {
                    name: 'notes',
                    component: 'TwinEditor',
                    defaultValue: basicData?.notes || '',
                    className: 'h-200'
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        }
    ]

    return (
        <SingleFormLayout action='/api/app/supplier/updateSupplier' onSubmit={getData} sections={fields} userPermissions={userPermissions} />
    )
}

export default SupplierNotes